angular
	.module('AutoPrequal')
	.controller('welcomeCtrl', welcomeCtrl);

welcomeCtrl.$inject = ['$scope', '$rootScope', '$timeout', 'ScrollFactory', 'DataFactory'];

function welcomeCtrl($scope, $rootScope, $timeout, ScrollFactory, DataFactory) {
	$rootScope.progressCurrent = 0;
	$rootScope.progressMobCurrent = 0;

	$scope.content = DataFactory.appData.content;

	DataFactory.appData.state.startTime = new Date().getTime();

	//wait for loading to finish
	$scope.localContent = DataFactory.appData.content.welcome;
	var unwatch = $rootScope.$watch('loading', function (newVal, oldVal) {
		if (newVal !== oldVal && !newVal) {
			$scope.localContent = DataFactory.appData.content.welcome;
			$rootScope.scrolling = false;
			$rootScope.isLoaded = true;
			unwatch();
		}
	})

	updateUrlLanguage();

	$timeout(function () {
		var toggle = $('#tglCancel');
		$(".legalSup").click(function () {
			if (toggle.attr('aria-expanded') == 'false') {
				toggle.click();
			}
			var sup = $(this).attr("data-sup-id");
			$timeout(function () {
				$("#" + sup).focus();
			}, 400)
		})
	});

	var unwatchSession = null;
	$scope.nextStep = function () {
		var continueNextStep = function () {
			DataFactory.appData.applicant.appState.welcome = true;
			ScrollFactory.showStep("applicantName");
			ScrollFactory.goToStep("applicantName");
		}

		if ($rootScope.isLoadingSession) {
			$rootScope.forcedLoader = true;
			unwatchSession = $rootScope.$watch('isLoadingSession', function() {
				if (!$rootScope.isLoadingSession) {
					$rootScope.forcedLoader = false;
					continueNextStep();
					unwatchSession();
				}
			})
		} else {
			continueNextStep();
		}
	}

	function updateUrlLanguage() {
		var url = window.location.href;
		var search = window.location.search.replace(/\//, "");
		if (url.indexOf('lang=en') !== -1) {
			$rootScope.otherLangUrl = url.replace(/lang=en/, 'lang=fr');
		}
		else if (url.indexOf('lang=fr') !== -1) {
			$rootScope.otherLangUrl = url.replace(/lang=fr/, 'lang=en');
		}
		else if (incoming_lang === 'en') {
			if (window.location.search == "") {
				$rootScope.otherLangUrl = window.location.origin + window.location.pathname + "?lang=fr";
			}
			else {
				$rootScope.otherLangUrl = window.location.origin + window.location.pathname + search + "&lang=fr";
			}
		}
		else {
			if (window.location.search == "") {
				$rootScope.otherLangUrl = window.location.origin + window.location.pathname + "?lang=en";
			}
			else {
				$rootScope.otherLangUrl = window.location.origin + window.location.pathname + search + "&lang=en";
			}
		}
	}

	$scope.$on('$destroy', function () {
		unwatch();
		unwatchSession && unwatchSession();
	});
}
